import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Eye } from "lucide-react";
import { eaVerifyUrl } from "@/components/energy-analytics/analytics/EaDashboardCard";

// Staff: apre Energy Analytics come il cliente scelto (dentro si può cambiare cliente da "Vedi come cliente…").
export default function EaOpenClient({ company }) {
  const nav = useNavigate();
  const cid = company?.id;
  return (
    <div className="card-elevated p-5" data-testid="ea-open-client">
      <div className="flex items-center gap-2 font-display font-semibold text-slate-900"><Eye size={18} /> Apri Energy Analytics {company ? `di ${company.name}` : "del cliente selezionato"}</div>
      <p className="text-sm text-slate-500 mt-1">Vedi la piattaforma esattamente come il cliente, con i suoi dati. Dentro Energy Analytics puoi cambiare cliente dal menù "Vedi come cliente…" in alto a destra.</p>
      <div className="flex flex-wrap items-center gap-3 mt-4">

        <button onClick={() => nav(eaVerifyUrl(cid))} disabled={!cid} className="h-9 px-4 rounded-lg bg-slate-900 text-white text-sm font-semibold inline-flex items-center gap-2 disabled:opacity-50" data-testid="ea-open-client-go">Apri <ArrowRight size={15} /></button>
      </div>
    </div>
  );
}
